import { render, staticRenderFns } from "./Fudei.vue?vue&type=template&id=451f8e06"
import script from "./Fudei.vue?vue&type=script&lang=js"
export * from "./Fudei.vue?vue&type=script&lang=js"
import style0 from "./Fudei.vue?vue&type=style&index=0&id=451f8e06&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports